import { useRef } from 'react'
import { Section } from '@playbooks/core/src/interfaces/ActionCard'

import { useAppContext } from '../contexts/AppContext'
import useMountEffect from './useMountEffect'

export default function useOnSectionReady(data: Section) {
  const { onSectionReady } = useAppContext()
  const sectionRef = useRef<HTMLDivElement>(null)

  useMountEffect(() => {
    onSectionReady?.(sectionRef.current!, data)
  })

  return sectionRef
}
